import axios from "axios";
import { getSessionValue, getValue } from "../utils/utils";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Access-Control-Allow-Origin": "true",
    Authorization: null,
  },
});

export const setAuthToken = (token?: string) => {
  if (token) api.defaults.headers.Authorization = `bearer ${token}`;
};

api.interceptors.request.use((request) => {
  if (request.data instanceof FormData) {
    delete request.headers["Content-Type"];
    delete request.headers["content-type"];
    if (!request.transformRequest) {
      request.transformRequest = [];
    }
  }

  if (request.headers && !request.headers.Authorization) {
    let token = null;
    const sessionValue = getSessionValue("persist:session", true);
    const tokens = getValue("tokens", true);

    if (sessionValue && sessionValue.countryCode && tokens) {
      const countryCode = JSON.parse(sessionValue.countryCode);
      if (countryCode) token = tokens[countryCode];
    }
    if (token) {
      request.headers.Authorization = `bearer ${token}`;
    } else if (!request.headers.optionalToken) {
      // Evita token requerido en las rutas de login
      return {
        ...request,
        cancelToken: new axios.CancelToken((cancel) =>
          cancel("Cancel invalid request")
        ),
      };
    }
  }

  return request;
});

api.interceptors.response.use(
  (response) => {
    if (response.status === 204) {
      return response;
    }

    // cubre el caso de un download de un archivo
    if (response.status === 200 && response.request.responseType === "blob") {
      return response;
    }
    return response;
  },
  (error) => {
    if (!error.status && !error.response) {
      window.location.reload();
    }
    if (error.response) {
      if (error.response.status !== 401) {
        return error.response;
      }
    }
    // se agrega el atributo para saber que es un error de saga
    // eslint-disable-next-line
    error.httpError = true;

    throw error;
  }
);

export type ErrorResponse = {
  statusCode?: number;
  message?: string;
  error?: string;
  errors?: string[];
};

export type ApiResponse<T> = {
  status: number;
  data: T & ErrorResponse;
};
export type ApiResponseResult<T = {}> = {
  result: T & ErrorResponse;
};

export type ApiResponseGrid<T> = {
  result: {
    items: T[];
  };
  limit: number;
  offset: number;
  hasMore: boolean;
};

export const remove = (path: string, body?: object) => {
  return api.delete(path, { params: body });
};

export const get = (path: string, query?: object) => {
  return api.get(path, { params: query });
};

export const post = (path: string, body: object, config?: object) => {
  return api.post(path, body, config);
};

export const put = (path: string, body?: object, config?: object) => {
  return api.put(path, body, config);
};

export const patch = (path: string, body?: object, config?: object) => {
  return api.patch(path, body, config);
};
export default api;
